export enum BankPaymentType {
  IncomingInvoiceManualPayment = 0,
  IncomingInvoicePaymentFile = 1,
  ReceiptPayoutFile = 2,
  SalaryPayout = 3,
  ManualPayout = 4,
}

export enum BankIdPaymentType {
  IncomingInvoice = 0,
  Receipt = 1,
  SalaryPayout = 2,
  ManualPayout = 3,
  PersonSalaryEntry = 4,
  WintSalaryEntry = 5,
}
